module.exports = __webpack_public_path__ + "img/profile-edit.b3e5c3a1.svg";